/// <reference path="../_all.ts" />

module shoppinglist {
  'use strict';

  ShoppingListTableDirective.$inject = ['$timeout', '$filter', 'shoppingListService', '$mdDialog', '$templateCache', 'pageMetaService',];
  export function ShoppingListTableDirective(
    $timeout : ng.ITimeoutService
    , $filter : ng.IFilterService
    , shoppingListService : IShoppingListService
    , $mdDialog : ng.material.IDialogService
    , $templateCache : ng.ITemplateCacheService
    , pageMetaService: navigation.IPageMetaService): ng.IDirective {

    var myTemplate = <string> $templateCache.get('shoppinglist/ShoppingListTableIndividuellDirective') || <string> $templateCache.get('shoppinglist/ShoppingListTableDirective') || "";

    return {
      restrict: 'AE'
      , scope : {
        shoppingList : "="
        , hl : "=languageName"
        , requestOnGoing: "="
        , onOpenPartDetail : '&'
      }
      , replace: true
      , template: myTemplate
      , link: function (scope: IShoppingListDirectiveDirectiveScope, element: JQuery, attr: ng.IAttributes) {

        scope.meta = pageMetaService.getPageMeta;

  
        scope.showNettoNotification = shoppingListService.getLocalSetting("ShowNettoNotification", true);
        scope.hideNettoNotification = () => { 
          shoppingListService.setLocalSetting("ShowNettoNotification", false); 
          scope.showNettoNotification = false;
        }

        scope.yourPriceEnabled = shoppingListService.getLocalSetting("YourPriceEnabled", false);
        scope.setYourPriceEnabled = (isEnabled: boolean) => { shoppingListService.setLocalSetting("YourPriceEnabled", isEnabled); };

        scope.$watch('yourPriceEnabled', (newValue : boolean, oldValue : boolean) => {
          if (oldValue != newValue) {
            scope.setYourPriceEnabled(newValue);
          }
        });
        
        scope.$on('cartUpdated', function(event, data) {             
          if (!scope.$$phase && ! scope.$root.$$phase) scope.$apply();
        });
                  
        scope.getTotalQty = function() {
          scope.Availability = shoppingListService.calculateAvailability(scope.shoppingList); 
          return shoppingListService.getQtySummary(scope.shoppingList);
        };

        scope.getTotal = function (yourPriceEnabled : boolean) {
          return shoppingListService.getTotal(scope.shoppingList, yourPriceEnabled); 
        };

        scope.removeLine = function(index) {
          if (!scope.partForm.$valid) return;
          scope.shoppingList.Lines.splice(index, 1); //remove
          scope.shoppingList.dirty = true;              
        };

          
        scope.clear = function(index) {
          scope.shoppingList.Lines = []; //remove all and everything
          scope.shoppingList.dirty = true;             
        };

        scope.changeQty = function(line, amount) {
          if (!scope.partForm.$valid) {
            line.invalid = true;
            return;
          }
          if (amount) {
            line.Qty = Math.max(line.Qty + amount, 0);
          }
          scope.shoppingList.dirty = true;
          line.invalid = false;
        };    
          
        scope.getAvailabilityText = function(line, hl)  {
          if (hl == 'D') return line.Availability.TextDe;
          if (hl == 'E') return line.Availability.TextEn;
        };

        scope.print = function() {        
          var printContents = element[0].innerHTML;

          printContents = printContents.replace(/md-toolbar/gmi, 'div');
          printContents = printContents.replace(/md-content/gmi, 'div');


          var popupWin = window.open('', '_blank');
          popupWin.document.open()
          popupWin.document.write('<html><head><title></title>'
            + '<link rel="stylesheet" type="text/css" href="/res/css/shoppinglist-print.css" />'
            + '</head><body onload="//window.print()">' + printContents + '</html>');


          popupWin.document.title = $('.header h3', popupWin.document).text();

          //$('md-toolbar', popupWin.document).replaceWith($('<div/>').attr('class','header').html($('md-toolbar').html()));
          //$('md-content', popupWin.document).replaceWith($('<div/>').attr('class','cart-art').html($('md-content').html()));


          //inject current date & user -> if we make it the angular way, we have to wait for $digest cycle to finish, 
          //which triggers the popup blocker, or it won't get populated because hidden
          $('.printdate i', popupWin.document).each(function() {
              var text = $(this).text();

              text = text.replace(/__ReplaceDate:(.*?)__/, function(a, b) {
                return $filter('date')(Date.now(),b);
              });

              text = text.replace(/__User__/, function(a, b) {
                return pageMetaService.getPageMeta(navigation.USERNAME);
              });

              $(this).text(text); 
          });

          $(".no-print", popupWin.document).empty();
          $(".flex, .flex-grow, .layout-column", popupWin.document).removeClass('flex flex-grow layout-column');


            
        };
          
        scope.buttonsDisabled = function() {        
          if (!scope.shoppingList || !scope.shoppingList.Lines || scope.shoppingList.Lines.length == 0) return true;
          if (scope.requestOnGoing) return true;
          return false;
        }
          
        scope.showSummary = function() {   
          if (!scope.shoppingList || !scope.shoppingList.Lines || scope.shoppingList.Lines.length == 0) return false;
          if (!scope.partForm || !scope.partForm.$valid) return false;
          return true;
        }

        
        scope.openModal = function(ev : MouseEvent) {
          $mdDialog.show(<ng.material.IDialogOptions>{
            controller: 'ShareModalCtrl',
            templateUrl: 'shoppinglist/ShareModalCtrl',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: ev,
            clickOutsideToClose:true,
            //fullscreen: true, // Only for -xs, -sm breakpoints.
            locals : {
              parentScope : scope 
            },
          })
          .then(function() {
            console.log('Modal closed at: ' + new Date());
          }, function() {
            console.log('Modal canceled at: ' + new Date());
          });
        };

        
        scope.openPartDetail = (ev: ng.IAngularEvent, p: part.Part) => {
          scope.onOpenPartDetail({ event: ev, part: p });
        }

      }

    };
  }
};